export function getUniqueTags(nodes) {
  const tagSet = new Set();
  nodes.forEach(node => {
    if (Array.isArray(node.tags)) {
      node.tags.forEach(tag => tagSet.add(tag));
    }
  });
  return Array.from(tagSet);
} 